import Vue from 'vue'

import cropImage from './src/crop-image.vue';
import cropImagePreview from './src/crop-image-preview.vue';
import cropImageFrame from './src/crop-image-frame.vue';
import cropImageBackground from './src/crop-image-background.vue';

var components = [
  cropImage,
  cropImagePreview,
  cropImageFrame,
  cropImageBackground
]

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/ui-components/~/crop-image/index.js
// module id = 544
// module chunks = 0